module.exports = __webpack_public_path__ + "static/starCharge/img/shareImg.bee7d4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/starcharge/assets/img/shareImg.png
// module id = K3WW
// module chunks = 81